import { render, staticRenderFns } from "./rtmlog.vue?vue&type=template&id=15c2acaf&scoped=true"
import script from "./rtmlog.vue?vue&type=script&lang=js"
export * from "./rtmlog.vue?vue&type=script&lang=js"
import style0 from "./rtmlog.vue?vue&type=style&index=0&id=15c2acaf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c2acaf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15c2acaf')) {
      api.createRecord('15c2acaf', component.options)
    } else {
      api.reload('15c2acaf', component.options)
    }
    module.hot.accept("./rtmlog.vue?vue&type=template&id=15c2acaf&scoped=true", function () {
      api.rerender('15c2acaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/rtmlog.vue"
export default component.exports